import React from "react";
import { observer } from "mobx-react";
import {
  generatePath,
  useNavigate,
  useParams,
} from "react-router-dom";

import WorkoutDetailsStore from "stores/WorkoutDetailsStore";

import { NavListItem } from "components/Layout";

import { capitalize } from "utils/common";

import ROUTES from "navigation/routes";
type Props = {
  workoutLabel?: string;
};

const NavList: React.FC<Props> = observer(() => {
  const navigate = useNavigate();
  const params = useParams<{ workoutId?: string; movementId?: string }>();


  const workoutId = params.workoutId ? Number.parseInt(params.workoutId) : undefined;
  const movementId = params.movementId ? Number.parseInt(params.movementId) : undefined;

  const workoutTitle = React.useMemo(() => {
    const title =
      WorkoutDetailsStore.details?.label || WorkoutDetailsStore.details?.title;
    return title ? capitalize(title) : undefined;
  }, [WorkoutDetailsStore.details]);

  const movementTitle = React.useMemo(() => {
    return movementId
      ? capitalize(
          WorkoutDetailsStore.getMovementDetails(movementId)?.title,
        )
      : undefined;
  }, [movementId]);

  const onClick = React.useCallback(
    (route: string, routeParams?: any) => () => {
      navigate(generatePath(route, routeParams));
    },
    [navigate]
  );

  const navListItems = React.useMemo(() => {
    if (workoutId) {
      const firstItem = workoutId
        ? {
            title: workoutTitle,
            onClick: onClick(ROUTES.WORKOUT_SEARCH_WORKOUT_DETAILS, {
              workoutId: workoutId,
            }),
          }
        : undefined;
      const secondItem = movementId
        ? {
            title: movementTitle,
            onClick: onClick(
              ROUTES.WORKOUT_SEARCH_WORKOUT_DETAILS_MOVEMENT_DETAILS,
              {
                workoutId: workoutId,
                movementId: movementId,
              },
            ),
          }
        : undefined;

      return [firstItem, secondItem].filter(Boolean);
    }
    return [];
  }, [workoutId, movementId, workoutTitle, movementTitle, onClick]);

  return (
    <>
      {navListItems.map((item: any, index: number) => (
        <NavListItem
          key={`${index}-${item.title}`}
          title={item.title}
          onClick={item.onClick}
          isLastItem={index === navListItems.length - 1}
        />
      ))}
    </>
  );
});

export default NavList;
